import React, { useEffect, useState } from "react";

const SALES_STATS = [
  { value: "45+", label: "Jahre Erfahrung bei REPEXO Sales" },
  { value: "40+", label: "Jahre Erfahrung bei REPEXO Medical" },
  { value: "5.400+", label: "besetzte Positionen im Sales" },
  { value: "4.100+", label: "besetzte Positionen im Medical" },
  { value: "4.500+", label: "Kunden" },
];

const MEDICAL_STATS = [
  { value: "45+", label: "Jahre Erfahrung bei REPEXO Sales" },
  { value: "40+", label: "Jahre Erfahrung bei REPEXO Medical" },
  { value: "5.400+", label: "besetzte Positionen im Sales" },
  { value: "4.100+", label: "besetzte Positionen im Medical" },
  { value: "4.500+", label: "Kunden" },
];

export default function StatsAndLogosMarquee({ site = "medical" }) {
  const stats = site === "sales" ? SALES_STATS : MEDICAL_STATS;
  const [logos, setLogos] = useState([]);

  useEffect(() => {
    const loadLogos = async () => {
      try {
        const basePath = `/logos/${site}`;

        const response = await fetch(
          `${basePath}/logos.json?v=${Date.now()}`
        );

        if (!response.ok) {
          throw new Error("Logo-Liste konnte nicht geladen werden");
        }

        const files = await response.json();

        if (!Array.isArray(files)) {
          throw new Error("logos.json enthält kein Array");
        }

        setLogos(
          files.map((filename) => `${basePath}/${filename}`)
        );
      } catch (error) {
        console.error("Fehler beim Laden der Referenzlogos:", error);
        setLogos([]);
      }
    };

    loadLogos();
  }, [site]);

  return (
    <section className="bg-[#f3f4f6] py-10">
      <div className="container-app">
        <div className="rounded-3xl bg-white/95 px-6 py-8 shadow-[0_18px_45px_rgba(0,0,0,0.10)] sm:px-10 sm:py-10">
          <p className="text-center text-[14px] font-semibold uppercase tracking-[0.18em] text-gray-500">
            REPEXO IN ZAHLEN
          </p>

          <h2 className="mt-3 text-xl sm:text-3xl md:text-4xl font-semibold md:font-medium text-gray-900 text-center">
            Kennzahlen aus Executive Search
          </h2>

          {/* Stats row */}
          <div className="mt-6 grid gap-4 sm:grid-cols-2 lg:grid-cols-5">
            {stats.map((s) => (
              <div
                key={s.label}
                className="rounded-2xl btn-bg px-4 py-4 text-center"
              >
                <div className="text-2xl font-semibold tracking-tight text-gray-900 sm:text-[26px]">
                  {s.value}
                </div>

                <div className="mt-2 text-[11px] font-medium uppercase tracking-[0.16em] text-gray-600">
                  {s.label}
                </div>
              </div>
            ))}
          </div>

          {/* Logos marquee */}
          <div className="mt-8 overflow-hidden">
            <div className="relative group">
              <div className="pointer-events-none absolute inset-y-0 left-0 w-16 bg-gradient-to-r from-white to-transparent" />
              <div className="pointer-events-none absolute inset-y-0 right-0 w-16 bg-gradient-to-l from-white to-transparent" />

              <div className="marquee-track group-hover:[animation-play-state:paused]">
                {[...Array(2)].map((_, loopIndex) => (
                  <div
                    key={loopIndex}
                    className="flex items-center gap-10 px-4"
                  >
                    {logos.map((logo, i) => (
                      <div
                        key={`${loopIndex}-${i}`}
                        className="flex h-32 items-center justify-center bg-white p-2"
                      >
                        <img
                          src={logo}
                          alt={`Logo eines REPEXO-Kundenunternehmens (${i + 1})`}
                          className="max-h-full max-w-full object-contain grayscale brightness-1"
                        />
                      </div>
                    ))}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}